
export class RequestTypeModel {
   RequestTypeId:number; 
   Name :string;
}